export const VIVA_EVENT_ID: string = 'x-viva-eventid';
export const VIVA_CORRELATION_ID: string = 'x-viva-correlationid';
